import { Box, Button as MuiButton } from '@mui/material';
import React from 'react';

import { ButtonProps } from './types';
import styles from './button.module.scss';

const Button = ({ children, loading, ...props }: ButtonProps) => {
  return (
    <MuiButton {...props} disabled={loading || props.disabled}>
      {loading ? (
        <Box className={styles['button-loader']}>
          <Box component="span" className={styles['dot-spinner']}>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
          </Box>
        </Box>
      ) : (
        children
      )}
    </MuiButton>
  );
};

export default Button;
